export default class ColorCart {
  constructor(irodamabtn) {
    this.$ = irodamabtn;
    this.jancode = this.$.closest('.js-zaiko').dataset.shohincd;
    this.irodamaZaikoContainer = this.$.closest('.js-zaiko');
    this.container = this.$.closest('.js-colorcart');
    this.irodamas = Array.from(this.container.querySelectorAll('.js-colorcart-irodama'));
    this.selectClass = 'm-selected';
    this.colorname = this.$.querySelector('img').getAttribute('src').split('/').pop().slice(0,-4);
    this.cart = this.container.querySelector('.js-colorcart-cart');
    // this.display = this.container.querySelector('.js-colorcart-display');
    // this.displayUnits = Array.from(this.display.querySelectorAll('.mod-colorcart-display-unit'));
    // this.displayClass = this.display.getAttribute('class');
    this.btns = this.container.querySelector('.js-colorcart-cartbtn');
    this.btnDef = this.container.querySelector('.js-colorcart-btn-default');
    this.cartbtns = Array.from(this.container.querySelectorAll('.js-colorcart-link'))
    this.bind();
  }

  bind() {
    this.$.addEventListener('click', this.irodamaClick.bind(this));

    let self = this
    this.irodamas.forEach(irodama =>{
      irodama.onclick = function(){
        self.irodamas.forEach($iroda => $iroda.classList.remove('active'))
        this.classList.add('active')
      }
    })
  }

  irodamaClick(){
    // this.displayUnits.forEach(unit => {
    //   if (unit.classList.contains(this.colorname)) {
    //     unit.style.display = 'block';
    //   } else {
    //     unit.style.display = 'none';
    //   }
    // });
    let scSerial = this.$.dataset.colorcart_serial;
    this.linkSet(this.jancode, scSerial);
    let zaikoTarget = '.zaikokbn' + this.irodamaZaikoContainer.dataset.zaiko;
    this.btnDef.style.display = 'none';
    this.btns.querySelector('.zaikokbn1').style.display = 'none';
    this.btns.querySelector('.zaikokbn2').style.display = 'none';
    this.btns.querySelector('.zaikokbn0').style.display = 'none';
    this.btns.querySelector('.zaikokbn9').style.display = 'none';
    this.btns.querySelector(zaikoTarget).style.display = 'block';
  }

  linkSet(jancode,scSerial){
    //.js-colorcart-linkにカートリンク設置
    let itemCartParam = '&sweb_shohin_cd=' + jancode;
    let cartUrl = 'https://www.shiseido.co.jp/sw/products/SWFG070220.seam?actionMethod=/products%2FSWFG070220.xhtml%3AsWFG070220Action.addCartShohin' + String(itemCartParam) + '&online_shohin_ctlg_kbn=1&keyword_flg=1';
    this.cartbtns.forEach(link => {
      link.setAttribute('href',cartUrl);
      link.setAttribute('onclick', "_sc.gene_click(\'cartbtn_" + jancode + "_colorcart" + scSerial + "\', this.href)");
    });
  }

}

